import { Component, ChangeDetectionStrategy } from '@angular/core'

@Component({
    selector: 'sq-sidebar-header',
    imports: [],
    templateUrl: './sidebar-header.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    host: {
        class: 'sidebar-header border-bottom',
    },
})
export class SidebarHeaderComponent {}
